import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import { IconButton } from '@material-ui/core'
import clsx from 'clsx'
import { useElementTreeStore } from 'components/ElementsTree/ElementsTreeStore'
import { leftMostPaneStyles } from 'components/ElementsTree/styles/leftMostPaneStyles'
import React from 'react'
import CategoryToggleIcon from '../CategoryPanel/CategoryToggleIcon'
import ElementsToggleIcon from '../ElementsPanel/ElementsToggleIcon'

export interface LeftMostPaneButtonContainerStyleProps {}

export type TogglePanelType = 'category' | 'elements'
export interface LeftMostPaneButtonContainerProps {
    changeTab: (tab: string) => void
    contentTeamFromStudioPage?: boolean

    isDivisionSelected?: boolean
}

export const LeftMostPaneButtonContainer = ({
    changeTab,
    contentTeamFromStudioPage,
    isDivisionSelected,
}: LeftMostPaneButtonContainerProps) => {
    const currentPane = useElementTreeStore((store) => store.currentPane)
    const showLeftMostPane = useElementTreeStore(
        (store) => store.showLeftMostPane
    )
    const isCategoryActive = currentPane === 'category'
    const isElementsActive = currentPane === 'elements'
    const classes = leftMostPaneStyles({ showLeftMostPane, currentPane })
    return (
        <div className={classes.buttonContainer}>
            {!contentTeamFromStudioPage && (
                <HoverTooltip text="Category" placements={['right']}>
                    <IconButton
                        size="small"
                        onClick={() => changeTab('category')}
                        data-testid="categoryPanelLeftPane"
                        className={clsx(
                            classes.leftPaneButton,
                            isCategoryActive && classes.activeLeftPane
                        )}
                        disabled={isDivisionSelected}
                    >
                        <CategoryToggleIcon
                            className={
                                isCategoryActive
                                    ? classes.leftPaneIconActive
                                    : isDivisionSelected
                                    ? classes.leftPaneIconDisabled
                                    : classes.leftPaneIcon
                            }
                        />
                    </IconButton>
                </HoverTooltip>
            )}
            <HoverTooltip text="Elements Panel" placements={['right']}>
                <IconButton
                    size="small"
                    data-testid="elementsToggleLeftPane"
                    onClick={() => changeTab('elements')}
                    className={clsx(
                        classes.leftPaneButton,
                        isElementsActive && classes.activeLeftPane
                    )}
                >
                    <ElementsToggleIcon
                        className={
                            isElementsActive
                                ? classes.leftPaneIconActive
                                : classes.leftPaneIcon
                        }
                    />
                </IconButton>
            </HoverTooltip>
        </div>
    )
}
